var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2024_75436)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2024_75436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0238 14.2791C12.821 14.2791 13.5856 13.9503 14.1493 13.3652C14.713 12.7801 15.0297 11.9865 15.0297 11.1591C15.0297 10.3316 14.713 9.538 14.1493 8.95289C13.5856 8.36778 12.821 8.03906 12.0238 8.03906C11.2265 8.03906 10.462 8.36778 9.89824 8.95289C9.33452 9.538 9.01782 10.3316 9.01782 11.1591C9.01782 11.9865 9.33452 12.7801 9.89824 13.3652C10.462 13.9503 11.2265 14.2791 12.0238 14.2791Z",
    stroke: "#F79E1B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0238 3.87891C19.2381 3.87891 21.0416 5.75091 21.0416 13.2389C21.0416 20.7269 19.2381 22.5989 12.0238 22.5989C4.80955 22.5989 3.00598 20.7269 3.00598 13.2389C3.00598 5.75091 4.80955 3.87891 12.0238 3.87891Z",
    stroke: "#F79E1B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01184 21.6124V21.5604C6.01184 20.4571 6.4341 19.399 7.18574 18.6188C7.93737 17.8387 8.9568 17.4004 10.0198 17.4004H14.0277C15.0907 17.4004 16.1101 17.8387 16.8617 18.6188C17.6134 19.399 18.0356 20.4571 18.0356 21.5604V21.6124",
    stroke: "#F79E1B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2024_75436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0476,
    height: 24.96,
    fill: "white",
    transform: "translate(0 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2024_75436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0476,
    height: 24.96,
    fill: "white",
    transform: "translate(0 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserOrange);
export default __webpack_public_path__ + "static/media/ic-user-orange.b28272f9aa3b4220c143798c17156580.svg";
export { ForwardRef as ReactComponent };